/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const StyledRadioButtonDropdown = styled.section`
  /* background-color: yellow; */
  // border: 1px solid #e7e7e7;
  border-radius: 5px;
  background-color: #ffffff;
  & .dropdown-head {
    padding: 12px 24px;
    border-radius: 4px 4px 0 0;
    display: flex;
    justify-content: space-between;
  }
  & .dropdown-checked-head {
    // background-color: #effaff;
  }
  & .dropdown-collapsed-head {
    /* border-bottom: 0px; */
  }
  & .dropdown-disabled-head {
    /* border-bottom: 0px; */
    opacity: 0.5;
    pointer-events: none;
    user-select: none;
  }
  & .content {
    padding: 16px 24px;
    // border-top: 1px solid #e7e7e7;
  }
  & button:focus {
    outline: none;
  }

  
  section[style*="border: 1px solid #e7e7e7"] {
  border: none !important;
}
`;

export const RadioContainer = styled.div`
 & p {
    font-size: 16px;
    line-height: 24px;
  }
  & label {
    width: auto;
    margin-right: 12px;
  }
  & label::after {
    left: -8px;
    width: 165%;
    @media screen and (min-width: 768px) {
      width: 150%;
    }
  }
`;

export const WrapperRadio = styled.div`
  & > div {
    display: flex;
    & > div {
      flex: 0 0 40px;
      /* justify-content: start !important; */
    }
  }
`;

